require('./OKStatusIcon.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const classnames = require('classnames');

// @ constants
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');

const OKStatusIcon = props => {
    const { documentTypeLabel, error = false, hasCeaCode = false, status, wrapperClasses = '' } = props;

    const iconClasses = classnames(
        'icon status-icon',
        {
            'document-none': !hasCeaCode && !error && (status === DOCUMENTS_STATUS.PEND_APORTAR || status === DOCUMENTS_STATUS.NONE),
            'document-pending-validation': !hasCeaCode && !error && (status === DOCUMENTS_STATUS.PEND_VAL || status === DOCUMENTS_STATUS.BORRADOR || status === DOCUMENTS_STATUS.PEND_RESP_OCR),
            'document-not-valid': !hasCeaCode && status === DOCUMENTS_STATUS.NO_VALIDO || error,
            'document-verified': !error && status === DOCUMENTS_STATUS.VERIFICADO || hasCeaCode
        }
    );

    return (
        <p className={wrapperClasses}>
            <i className={iconClasses}></i>
            {documentTypeLabel}
        </p>
    );
}

OKStatusIcon.propTypes = {
    documentTypeLabel: PropTypes.string.isRequired,
    error: PropTypes.boolean,
    hasCeaCode: PropTypes.boolean,
    status: PropTypes.string.isRequired,
    wrapperClasses: PropTypes.string
};

module.exports = OKStatusIcon;
